export function toDate(value) {
  if (!value) return null;
  if (typeof value?.toDate === "function") return value.toDate();
  const d = new Date(value);
  return Number.isFinite(d.getTime()) ? d : null;
}

export function daysUntil(dateValue) {
  const d = toDate(dateValue);
  if (!d) return null;

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const target = new Date(d);
  target.setHours(0, 0, 0, 0);

  return Math.ceil((target.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));
}

export function getCredentialExpirationStatus(expirationDate) {
  const days = daysUntil(expirationDate);

  if (days === null) {
    return {
      status: "missing",
      label: "Missing expiration",
      daysRemaining: null,
      severity: "warning",
    };
  }

  if (days < 0) {
    return {
      status: "expired",
      label: "Expired",
      daysRemaining: days,
      severity: "critical",
    };
  }

  if (days <= 30) {
    return {
      status: "critical",
      label: `Expires in ${days} day${days === 1 ? "" : "s"}`,
      daysRemaining: days,
      severity: "critical",
    };
  }

  if (days <= 60) {
    return {
      status: "warning",
      label: `Expires in ${days} days`,
      daysRemaining: days,
      severity: "warning",
    };
  }

  if (days <= 90) {
    return {
      status: "upcoming",
      label: `Expires in ${days} days`,
      daysRemaining: days,
      severity: "watch",
    };
  }

  return {
    status: "good",
    label: "Current",
    daysRemaining: days,
    severity: "healthy",
  };
}

export function buildWorkerCredentialExpirationRows(worker = {}) {
  const credentialMap = worker?.credentialMap || {};
  const rows = [];

  Object.entries(credentialMap).forEach(([key, credential]) => {
    const expirationDate =
      credential?.expirationDate ||
      credential?.expiresAt ||
      credential?.expiryDate ||
      credential?.expiration ||
      "";

    const result = getCredentialExpirationStatus(expirationDate);

    rows.push({
      workerUid: worker.uid || worker.id || "",
      workerName: worker.displayName || worker.name || worker.email || worker.uid || "",
      email: worker.email || "",
      credentialKey: key,
      credentialLabel:
        credential?.label ||
        credential?.name ||
        key.replaceAll("_", " ").toUpperCase(),
      expirationDate,
      ...result,
    });
  });

  return rows;
}

export function buildCredentialExpirationSummary(workers = []) {
  const rows = workers.flatMap((worker) =>
    buildWorkerCredentialExpirationRows(worker)
  );

  const attentionRows = rows.filter((row) =>
    ["expired", "critical", "warning", "upcoming", "missing"].includes(row.status)
  );

  return {
    rows,
    attentionRows,
    expired: rows.filter((r) => r.status === "expired").length,
    critical: rows.filter((r) => r.status === "critical").length,
    warning: rows.filter((r) => r.status === "warning").length,
    upcoming: rows.filter((r) => r.status === "upcoming").length,
    missing: rows.filter((r) => r.status === "missing").length,
    totalAttention: attentionRows.length,
  };
}